import React, { useState, useEffect } from 'react'
import {
  CommonHeader,
  DropDown,
  RadioContainer,
  ErrorSuccessModal,
  Loader,
  ConfirmationModal
} from '../../components/commons';
import { ChangeUserPassword, ChangeUserName } from '../../components/ChangeClientPassword';
import { connect } from 'react-redux';
import { RootState } from '../../redux/rootReducers';
import { FinacUsersType } from '../../redux/auth/authTypes';
import {
  getAllFinacUsersAction,
  changeFinacFirstLastNameAction,
  changeFinacUserPasswordAction,
  resetAuthError,
  resetAuthSuccess,
  resetSession,
  resetFinacUsersList
} from '../../redux/auth';
import {
  ChangeFinacUserFirstLastNameType,
  ChangeFinacUserPasswordType,
  GetAllFinacUserPayloadType
} from '../../commonTypes/authTypes';
import { checkHasLowerLetter, checkHasNumber, checkHasSpecial, checkHasUpperLetter, convertPasswordToHash } from '../../utils/commonFunctions';

type RadioTypes = {
  id: string;
  name: string;
}

const RADIO_OPTIONS: RadioTypes[] = [
  {
    id: 'change_password',
    name: 'Change User Password'
  },
  {
    id: 'first_last_name',
    name: 'Change First & Last Name'
  }
]

type PasswordType = {
  newPassword: string;
  confirmNewPassword: string;
}

type NameDataType = {
  firstName: string;
  lastName: string;
}

type finacUserListType = {
  value: string | undefined;
  label: string | undefined;
}

export type PasswordResult = {
  atLeast: boolean;
  upperCase: boolean;
  special: boolean;
  lowerCase: boolean;
  number: boolean
}

type AppProps = {
  token: string | null;
  success: number | null;
  fetching: boolean;
  error: string | null;
  statusCode: number | null;
  finacUsersList: any;
  dispatchGetAllFinacUsersAction: (data: GetAllFinacUserPayloadType) => void;
  dispatchChangeFinacUserPasswordAction: (data: ChangeFinacUserPasswordType) => void;
  dispatchChangeFinacFirstLastNameAction: (data: ChangeFinacUserFirstLastNameType) => void;
  dispatchResetAuthSuccess: () => void;
  dispatchResetAuthError: () => void;
  dispatchResetSession: () => void;
  dispatchResetFinacUsersList: () => void;
}

const ChangeClientPassword = ({
  token,
  success,
  statusCode,
  fetching,
  error,
  dispatchGetAllFinacUsersAction,
  finacUsersList,
  dispatchChangeFinacUserPasswordAction,
  dispatchChangeFinacFirstLastNameAction,
  dispatchResetAuthError,
  dispatchResetAuthSuccess,
  dispatchResetSession,
  dispatchResetFinacUsersList
}: AppProps) => {

  const [userId, setUserId] = useState<number | null>(null);
  const [passwordData, setPasswordData] = useState<PasswordType>({
    newPassword: "",
    confirmNewPassword: ""
  });
  const [nameData, setNameData] = useState<NameDataType>({
    firstName: "",
    lastName: ""
  });
  const [newPasswordError, setNewPasswordError] = useState<string>('');
  const [passwordValidationError, setPasswordValidationError] = useState<string>('');
  const [confirmNewPasswordError, setConfirmNewPasswordError] = useState<string>('');
  const [firstNameError, setFirstnameError] = useState<string>('');
  const [toggleNewPassword, setToggleNewPassword] = useState<boolean>(false);
  const [toggleConfirmPassword, setToggleConfirmPassword] = useState<boolean>(false);
  const [radioValue, setRadioValue] = useState<string>('change_password');
  const [finalFinacUserList, setFinalFinacUserList] = useState<finacUserListType[] | []>([]);
  const [userSelected, setUserSelected] = useState<any>({
    value: null,
    label: 'Select User...'
  });
  const [passwordValidation, setPasswordValidation] = useState<PasswordResult>({
    atLeast: false,
    upperCase: false,
    special: false,
    lowerCase: false,
    number: false,
  });
  const [passwordPopUpShow, serPasswordPopUpshow] = useState(false);
  const popOver = (e: any) => {
    serPasswordPopUpshow(false);
  };

  useEffect(() => {
    if (token) {
      const finalData = {
        token,
        user_type: 'all',
        status: 1
      }
      dispatchGetAllFinacUsersAction(finalData);
      dispatchResetAuthError();
      dispatchResetAuthSuccess();
      dispatchResetFinacUsersList();
    }
  }, []);

  useEffect(() => {
    if (finacUsersList?.data?.length > 0) {
      let finalClientData = finacUsersList?.data?.map((client: FinacUsersType) => {
        return {
          value: client.user_id,
          label: client.email
        }
      });
      setFinalFinacUserList(finalClientData)
    }
  }, [finacUsersList]);

  const handleChangeClient = (client: any) => {
    setUserId(client.value);
    setUserSelected(client);
  }

  const handleSetRadioValue = (value: string) => {
    setRadioValue(value);
    if (value === 'change_password') {
      setNameData((prevState) => ({
        ...prevState,
        firstName: "",
        lastName: ""
      }));
      setFirstnameError("");
    } else if (value === 'first_last_name') {
      setPasswordData((prevState) => ({
        ...prevState,
        newPassword: "",
        confirmNewPassword: ""
      }));
      setNewPasswordError("");
      setConfirmNewPasswordError("")
    }
  }

  const handleChangeNewPassword = (event: any) => {
    serPasswordPopUpshow(true);
    setPasswordData((prevState) => ({
      ...prevState,
      newPassword: event.target.value.trim()
    }));

    if (confirmNewPasswordError) {
      setConfirmNewPasswordError("")
    }

    let specialCharacterValue = checkHasSpecial(event.target.value);
    let uppercaseLetterValue = checkHasUpperLetter(event.target.value);
    let lowercaseLetterValue = checkHasLowerLetter(event.target.value);
    let numbercaseLetterValue = checkHasNumber(event.target.value);
    if (specialCharacterValue && uppercaseLetterValue && lowercaseLetterValue && event.target.value.length >= 8) {
      setPasswordValidationError('')
    }
    setPasswordValidation((prev: PasswordResult) => ({
      ...prev,
      ...(!!specialCharacterValue && { special: true }),
      ...(!!uppercaseLetterValue && { upperCase: true }),
      ...(!!lowercaseLetterValue && { lowerCase: true }),
      ...(!!numbercaseLetterValue && { number: true }),
      ...(!!(event.target.value.length >= 8) && { atLeast: true }),
      ...(!specialCharacterValue && { special: false }),
      ...(!uppercaseLetterValue && { upperCase: false }),
      ...(!lowercaseLetterValue && { lowerCase: false }),
      ...(!numbercaseLetterValue && { number: false }),
      ...(!(event.target.value.length >= 8) && { atLeast: false }),
    }))
    if (newPasswordError) {
      setNewPasswordError('');
    }
  }

  const handleChangeConfirmPassword = (event: any) => {
    setPasswordData((prevState) => ({
      ...prevState,
      confirmNewPassword: event.target.value.trim()
    }));

    if (confirmNewPasswordError) {
      setConfirmNewPasswordError('');
    }
  }

  const handleSetFirstName = (event: any) => {
    setNameData((prevState) => ({
      ...prevState,
      firstName: event.target.value
    }));

    if (firstNameError) {
      setFirstnameError('');
    }
  }

  const handleSetLastName = (event: any) => {
    setNameData((prevState) => ({
      ...prevState,
      lastName: event.target.value
    }))
  }

  const handleToggleNewPassword = () => {
    setToggleNewPassword(!toggleNewPassword);
  }

  const handleToggleConfirmNewPassword = () => {
    setToggleConfirmPassword(!toggleConfirmPassword);
  }

  const handleSubmitData = async () => {
    if (radioValue === 'change_password') {
      if (passwordData?.confirmNewPassword &&
        passwordData?.newPassword &&
        passwordData?.confirmNewPassword === passwordData?.newPassword && !Object.values(passwordValidation).includes(false)
      ) {
        let finalNewPassword = await convertPasswordToHash(passwordData?.newPassword);
        let finalConfirmNewPassword = await convertPasswordToHash(passwordData?.confirmNewPassword);

        let finalData: ChangeFinacUserPasswordType = {
          token,
          user_id: userId,
          newPassword: finalNewPassword,
          confirmNewPassword: finalConfirmNewPassword
        }
        setConfirmNewPasswordError("")
        dispatchChangeFinacUserPasswordAction(finalData);
      }
      else if (!passwordData?.newPassword) {
        if (!passwordData?.newPassword) {
          setNewPasswordError('Required');
        }
        if (!passwordData?.confirmNewPassword) {
          setConfirmNewPasswordError('Required')
        }
      }
      else if (passwordData?.newPassword?.length > 0 && Object.values(passwordValidation).includes(false)) {
        setPasswordValidationError("Password must meet requirements")
        if (!passwordData?.confirmNewPassword) {
          setConfirmNewPasswordError('Required')
        }
      }
      else if (passwordData?.confirmNewPassword &&
        passwordData?.newPassword &&
        passwordData?.newPassword !== passwordData?.confirmNewPassword
      ) {
        setConfirmNewPasswordError('Passwords Do Not Match!');
      }
      else if (!passwordData?.confirmNewPassword) {
        setConfirmNewPasswordError('Required')
      }
    } else if (radioValue === 'first_last_name') {
      if (nameData?.firstName) {
        let finalData: ChangeFinacUserFirstLastNameType = {
          token,
          user_id: userId,
          first_name: nameData?.firstName,
          last_name: nameData?.lastName
        }

        dispatchChangeFinacFirstLastNameAction(finalData);
      } else if (!nameData?.firstName) {
        setFirstnameError('Required');
      }
      else if (!passwordData?.confirmNewPassword) {
        setConfirmNewPasswordError('Required')
      }
    }
  }

  const handleResetData = () => {
    setUserSelected({
      value: null,
      label: 'Select User...'
    });

    setPasswordData((prevState) => ({
      ...prevState,
      newPassword: "",
      confirmNewPassword: ""
    }));

    setNameData((prevState) => ({
      ...prevState,
      firstName: "",
      lastName: ""
    }));

    setRadioValue('change_password');
  }

  const handleErrorModal = () => {
    if (success === 0) {
      if (statusCode === 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message="Session Expired!"
            buttonText="Logout"
            onPress={() => dispatchResetSession()}
            statusCode={statusCode}
          />
        )
      } else if ((!!error && statusCode !== 401)) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message={error}
            buttonText="OK"
            onPress={() => {
              dispatchResetAuthError();
            }}
          />
        )
      }
    }

    if (success === 1) {
      return (
        <ErrorSuccessModal
          type="success"
          isOpen={success === 1}
          title="Success"
          message="Credentials Updated Successfully!"
          buttonText="OK"
          onPress={() => {
            dispatchResetAuthSuccess();
            handleResetData();
          }}
          statusCode={statusCode}
        />
      )
    }

    return false;
  }

  return (
    <>
      <div className="row">
        <div className="col-md-12">
          <CommonHeader title="Change Credentials" />
        </div>
      </div>
      <div className="row">
        <div className="col-12">
          <div className="card p-4">
            <h6 className="mb-2"><strong>Choose an option to edit user details:</strong></h6>
            <div className="mt-2 mb-4">
              <RadioContainer
                optionsList={RADIO_OPTIONS}
                handleSetRadioValue={handleSetRadioValue}
                radioValue={radioValue}
              />
            </div>
            <div className="mb-4">
              <h6 className="mt-3 mb-2"><strong>Choose User:</strong></h6>
              <DropDown
                options={finalFinacUserList}
                extraClasses="w-25 mt-3"
                handleChange={handleChangeClient}
                value={userSelected}
              />
            </div>
            <div className="mt-1">
              <h6 className="mt-3 mb-2"><strong>Enter Details:</strong></h6>
              <div className="pl-2">
                {radioValue === 'change_password' ?
                  <ChangeUserPassword
                    popOver={popOver}
                    passwordValidation={passwordValidation}
                    passwordValidationError={passwordValidationError}
                    passwordPopUpShow={passwordPopUpShow}
                    handleToggleNewPassword={handleToggleNewPassword}
                    handleToggleConfirmNewPassword={handleToggleConfirmNewPassword}
                    toggleNewPassword={toggleNewPassword}
                    toggleConfirmPassword={toggleConfirmPassword}
                    disabled={!userSelected.value}
                    passwordData={passwordData}
                    handleChangeNewPassword={handleChangeNewPassword}
                    handleChangeConfirmPassword={handleChangeConfirmPassword}
                    newPasswordError={newPasswordError}
                    confirmNewPasswordError={confirmNewPasswordError}
                  /> :
                  <ChangeUserName
                    disabled={!userSelected.value}
                    handleSetFirstName={handleSetFirstName}
                    handleSetLastName={handleSetLastName}
                    firstNameError={firstNameError}
                    nameData={nameData}
                  />
                }
              </div>
            </div>
            <div className="d-flex justify-content-end">
              <button
                className="btn btn-primary"
                onClick={handleSubmitData}
                disabled={Object.values(passwordValidation).includes(false)}
              >
                Submit
              </button>
            </div>
          </div>
        </div>
        {handleErrorModal()}
        {fetching && <Loader />}
      </div>
    </>
  )
}

const mapStateToProps = (state: RootState) => ({
  token: state.auth.token,
  finacUsersList: state.auth.finacUsersList,
  success: state.auth.success,
  statusCode: state.auth.statusCode,
  error: state.auth.error,
  fetching: state.auth.fetching
});

const mapDispatchToProps = (dispatch: any) => ({
  dispatchGetAllFinacUsersAction: (data: GetAllFinacUserPayloadType) => dispatch(getAllFinacUsersAction(data)),
  dispatchChangeFinacUserPasswordAction: (data: ChangeFinacUserPasswordType) =>
    dispatch(changeFinacUserPasswordAction(data)),
  dispatchChangeFinacFirstLastNameAction: (data: ChangeFinacUserFirstLastNameType) =>
    dispatch(changeFinacFirstLastNameAction(data)),
  dispatchResetAuthError: () => dispatch(resetAuthError()),
  dispatchResetAuthSuccess: () => dispatch(resetAuthSuccess()),
  dispatchResetSession: () => dispatch(resetSession()),
  dispatchResetFinacUsersList: () => dispatch(resetFinacUsersList()),
})

export default connect(mapStateToProps, mapDispatchToProps)(ChangeClientPassword);